import React from "react";
import {
  BuildingOffice2Icon,
  VideoCameraIcon,
  Squares2X2Icon,
} from "@heroicons/react/24/outline";
import { CM_BOTH, CM_IN_PERSON, CM_VIRTUAL } from "../../utils/consultationModes";

const OPTIONS = [
  { value: CM_BOTH, label: "Ambas", icon: Squares2X2Icon },
  { value: CM_IN_PERSON, label: "Presencial", icon: BuildingOffice2Icon },
  { value: CM_VIRTUAL, label: "Virtual", icon: VideoCameraIcon },
];

/**
 * Selector segmentado de modalidad de consulta (agenda pública).
 */
export default function ConsultationModePicker({ value, onChange, disabled = false }) {
  return (
    <div
      role="radiogroup"
      aria-label="Modalidad de consulta"
      className="grid grid-cols-3 gap-2"
    >
      {OPTIONS.map((opt) => {
        const Icon = opt.icon;
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={[
              "flex flex-col items-center justify-center gap-1.5 rounded-xl border px-3 py-3 text-center transition-colors",
              disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
              active
                ? "border-brand-lavender bg-brand-lavender text-white shadow-sm"
                : "border-brand-lavender/30 bg-white text-brand-navy hover:bg-brand-lilac/25",
            ].join(" ")}
          >
            <Icon className="h-5 w-5" aria-hidden />
            <span className="text-[0.875rem] font-semibold">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
